import axios from "../../../util/axios";

const PREFIX_URI = "/project/dev/schedule";

export default {
    /** 排期甘特任务数据（非已取消，含延期状态） */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 所属项目下拉选项 */
    queryProjectOptions: () => axios.get({url: `${PREFIX_URI}/queryProjectOptions`}),
    /** 批次下拉选项（可按项目过滤） */
    querySprintOptions: (projectId) => axios.get({url: `${PREFIX_URI}/querySprintOptions`, data: {projectId: projectId}}),
    /** 节点工时超载（平均工时>8 且未完成的节点） */
    queryOverloadNodes: (data) => axios.get({url: `${PREFIX_URI}/queryOverloadNodes`, data: data}),
};
